var _path, _g, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManifestReportsArchive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.623 0H2.62694C1.96427 0 1.375 0.4875 1.375 1.14844V22.7516C1.375 23.4125 1.96291 24 2.62422 24H12.225C12.4459 24 12.625 23.8211 12.625 23.6C12.625 23.379 12.4458 23.2 12.225 23.2H2.62422C2.40409 23.2 2.17502 22.9711 2.17502 22.7516V1.14844C2.17502 0.928922 2.40527 0.800016 2.62698 0.800016H18.6231C18.841 0.800016 18.975 0.931641 18.975 1.14689V15.15C18.975 15.3711 19.1541 15.55 19.375 15.55C19.5959 15.55 19.775 15.3711 19.775 15.15V1.14689C19.775 0.487125 19.2857 0 18.623 0Z",
    fill: "#334155"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7629_64850)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.8752 14.375C15.1282 14.375 15.3335 14.5803 15.3335 14.8333V15.75H17.1668C17.4198 15.75 17.6252 15.9553 17.6252 16.2083V21.7083H18.5418V22.625H8.4585V21.7083H9.37516V16.2083C9.37516 15.9553 9.5805 15.75 9.8335 15.75H11.6668V14.8333C11.6668 14.5803 11.8722 14.375 12.1252 14.375H14.8752ZM11.6668 16.6667H10.2918V21.7083H11.6668V16.6667ZM14.4168 16.6667H12.5835V21.7083H14.4168V16.6667ZM16.7085 16.6667H15.3335V21.7083H16.7085V16.6667ZM14.4168 15.2917H12.5835V15.75H14.4168V15.2917Z",
    fill: "#334155"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 2H3.5C3.22389 2 3 2.20523 3 2.45833V12.5417C3 12.6632 3.05268 12.7798 3.14643 12.8658C3.24018 12.9517 3.36741 13 3.5 13H17.5C17.6326 13 17.7598 12.9517 17.8536 12.8658C17.9473 12.7798 18 12.6632 18 12.5417V2.45833C18 2.33679 17.9473 2.22016 17.8536 2.13423C17.7598 2.04829 17.6326 2 17.5 2ZM17 4.75H8V2.91667H17V4.75ZM10.5 5.66667H12V12.0833H10.5V5.66667ZM9.5 12.0833H8V5.66667H9.5V12.0833ZM13 5.66667H14.5V12.0833H13V5.66667ZM7 2.91667V4.75H4V2.91667H7ZM4 5.66667H7V12.0833H4V5.66667ZM15.5 12.0833V5.66667H17V12.0833H15.5Z",
    fill: "#334155"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7629_64850"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 11,
    fill: "white",
    transform: "translate(8 13)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManifestReportsArchive);
export default __webpack_public_path__ + "static/media/manifestReportsArchive.7fc9349d016cebbc2ccb5ac75302e06d.svg";
export { ForwardRef as ReactComponent };